/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SecurityService {
    private securityBaseUrl = `${environment.securityBaseUrl}/api/featureToggle`;

    constructor(private http: HttpClient) {
    }

    getFeatureToggleEnabled(featureToggleKey: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.securityBaseUrl}/${featureToggleKey}`);
    }
}
